import React, { FC, useEffect } from 'react';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import {
    PropertyBox,
    PropertyLabel,
    PropertyList,
    PropertyListItemButton,
} from 'components/property-settings/property-shared-styles';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material';

type BitetrayMaterialProps = {
    handleSettings: (propertyName: string, settingValue: string | boolean) => void;
    material: string;
    softInside: boolean;
    isRequired?: boolean;
};
const BitetrayMaterial: FC<BitetrayMaterialProps> = ({ material, softInside, handleSettings, isRequired }) => {
    const { t: translate } = useTranslation(['construction-props']);
    const [selectedMaterial, setSelectedMaterial] = React.useState('');
    const [selectedSoftInside, setSelectedSoftInside] = React.useState(false);

    useEffect(() => {
        setSelectedMaterial(material || '');
    }, [material]);

    useEffect(() => {
        setSelectedSoftInside(softInside);
    }, [softInside]);

    const handleListItemClick = (material: string) => {
        setSelectedMaterial(material);
        handleSettings('material', material);
    };

    const handleSoftInside = (_event: React.SyntheticEvent, checked: boolean) => {
        setSelectedSoftInside(checked);
        handleSettings('softInside', checked);
    };

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('MATERIAL')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <PropertyList>
                {['Mjuk', 'Hård'].map((material) => {
                    return (
                        <PropertyListItemButton
                            key={material}
                            selected={selectedMaterial === material}
                            onClick={() => handleListItemClick(material)}
                        >
                            <ListItemText primary={material} primaryTypographyProps={{ fontSize: '13px' }} />
                        </PropertyListItemButton>
                    );
                })}
            </PropertyList>
            <FormControl component="fieldset">
                <FormGroup row>
                    <FormControlLabel
                        control={
                            <Checkbox color="secondary" checked={selectedSoftInside} onChange={handleSoftInside} />
                        }
                        label={translate('SOFT_INSIDE')}
                        labelPlacement="end"
                    />
                </FormGroup>
            </FormControl>
        </PropertyBox>
    );
};

export default BitetrayMaterial;
